import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

/**
 * Utility function to get the current user's auth token from Firebase Auth
 * Can be used outside of React components (e.g., in loaders, utilities)
 */

export async function getCurrentUserToken(): Promise<string | undefined> {
  try {
    // Get the default Firebase app and auth instance
    const app = getApp();
    const auth = getAuth(app);

    // Get current user and their ID token
    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken();
      return token;
    }

    return undefined;
  } catch (error) {
    console.error("Error getting auth token:", error);
    return undefined;
  }
}

/**
 * Utility function to get the current user from Firebase Auth
 * Can be used outside of React components
 */
export async function getCurrentUser() {
  try {
    const app = getApp();
    const auth = getAuth(app);

    return auth.currentUser;
  } catch (error) {
    console.error("Error getting current user:", error);
    return null;
  }
}
